import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    width: '100%'
  },
  button: {
    width: '1em',
    height: '1em'
  }
}));
